import React from "react";
import {
  InlineLoader,
  LoaderStyle,
} from "@adsk/acc-issues-common/components/primitive/InlineLoader";

export const InlineValueDisplay = ({
  children,
  loading,
  empty,
}: {
  children?: React.ReactNode;
  loading?: boolean;
  empty?: boolean;
}) => {
  if (loading) {
    return <InlineLoader loaderStyle={LoaderStyle.Text} />;
  }

  if (empty) {
    return <>{InlineValueDisplay.EMPTY}</>;
  }

  return <>{children}</>;
};

InlineValueDisplay.EMPTY = "-";
